import Big from "big.js";

/**
 * 申告漏れの計算（対象の値）
 * @param {Big} value 対象の値
 * @param {number} underreportingCoefficient 購入者購入数量
 * @returns {Big}
 */
const calcUnderreportingValue = (value: Big, underreportingCoefficient: number): Big =>
	value.mul(new Big(underreportingCoefficient).minus(1));

/**
 * 申告漏れの計算
 * (C) トライアル申告漏れ = (A) x ([SLCI申告漏れ補正係数]-1)
 * (D) リピート申告漏れ = (B) x ([SLCI申告漏れ補正係数]-1)
 * @param {Big} trialAfterCorrection (A)テスト品のトライアル購入数量(補正後)
 * @param {Big} repeat （B）購入者購入数量
 * @param {{ trial: number, repeat: number }} underreportingCoefficient SLCI申告漏れ補正係数
 */
export const calcUnderreporting = (
	trialAfterCorrection: Big,
	repeat: Big,
	underreportingCoefficient: number,
): { trial: Big; repeat: Big } => {
	return {
		trial: calcUnderreportingValue(trialAfterCorrection, underreportingCoefficient),
		repeat: calcUnderreportingValue(repeat, underreportingCoefficient),
	};
};
